import { useMemo } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { anyActiveWatchSelector, invitationTokenSelector, liveStreamActionsSelector, } from '@core/livestream/model';
import { useVideoIsLocked } from '@player/features/gatedVideo';
/**
 * @returns Whether any live stream is active. Active means that the live stream
 * is being interacted with. If the session has received an invitation token, it
 * is automatically considered as interacted with.
 */
export const useLiveStreamActiveUser = (video) => {
    const liveStreamId = video?.live_stream_id;
    const isVideoLocked = useVideoIsLocked(video);
    const invitationToken = useGlobalStore(invitationTokenSelector(liveStreamId));
    const isActive = useGlobalStore((state) => anyActiveWatchSelector(state));
    const { setActiveWatch, unsetActiveWatch, clearActiveWatches } = useGlobalStore(liveStreamActionsSelector);
    return useMemo(() => ({
        isActiveWatch: Boolean(isActive || invitationToken),
        setActiveWatch: () => {
            if (isVideoLocked) {
                return false;
            }
            setActiveWatch(liveStreamId ?? '');
            return true;
        },
        unsetActiveWatch: () => unsetActiveWatch(liveStreamId ?? ''),
        clearActiveWatches,
    }), [
        clearActiveWatches,
        invitationToken,
        isActive,
        liveStreamId,
        setActiveWatch,
        unsetActiveWatch,
        isVideoLocked,
    ]);
};
